<div class="labelled-checkbox">
  <div class="labelled-checkbox__checkbox">
    <ng-container
      *ngTemplateOutlet="templateRef; context: { id: id }"
    ></ng-container>
  </div>

  <label class="labelled-checkbox__label" [for]="id">
    <ng-content></ng-content>
  </label>
</div>
